import type {TourOperatorSpecials} from '@/redux/v1/hotels/list/models';

const stringifyTypes = (
  object?: Record<PropertyKey, Array<{type: unknown}>>
) => {
  const types = [];
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      for (const item of object[key]) {
        types.push(item.type);
      }
    }
  }
  return types.join(',');
};

export const mapHotelSpecials = (data?: TourOperatorSpecials): string => {
  return stringifyTypes(data);
};
